// Overview.jsx
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers, faUserCheck, faPlus } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Overview.css";

const API_URL = "https://aadyaacademy.org/api";

function Overview({ isMenuOpen }) {
  const [studentList, setStudentList] = useState([]);
  const [attendanceCount, setAttendanceCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    const teacherPhone = localStorage.getItem("userPhone");

    if (!teacherPhone) {
      toast.error("Teacher phone number is not available.", {
        position: "top-center",
      });
      setLoading(false);
      return;
    }

    try {
      const studentResponse = await axios.get(`${API_URL}/students/byTeacherPhone`, {
        params: { teacherPhone },
      });

      if (studentResponse.data.message) {
        setStudentList([]);
        toast.warn("No students found for this teacher.", {
          position: "top-center",
        });
      } else {
        setStudentList(studentResponse.data || []);
      }

      const attendanceResponse = await axios.get(`${API_URL}/attendance/byTeacherPhone`, {
        params: { teacherPhone },
      });

      if (attendanceResponse.data.message) {
        setAttendanceCount(0);
        toast.warn(attendanceResponse.data.message || "No attendance data found.", {
          position: "top-center",
        });
      } else {
        setAttendanceCount(attendanceResponse.data.attendanceCount || 0);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Error fetching data. Please try again.";
      toast.error(errorMessage, { position: "top-center" });
      console.error("Fetch error:", error);
      setAttendanceCount(0);
      setStudentList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const attendancePercentage =
    studentList.length === 0
      ? 0
      : ((attendanceCount / studentList.length) * 100).toFixed(2);

  return (
    <>
      <div className={`overview-container ${isMenuOpen ? "menu-open" : "menu-closed"}`}>
        <div className="overview-top">
          <h2>Overview</h2>
          <div className="report">
            <button
              className="generate-report-btn"
              onClick={() =>
                toast.info("Report generation not implemented yet.", {
                  position: "top-center",
                })
              }
              aria-label="Generate Report"
            >
              <FontAwesomeIcon icon={faPlus} className="plus-icon" />
              Generate Report
            </button>
          </div>
        </div>

        <div className="overview-content">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <>
              <div className="stat-card">
                <div className="stat-header">
                  <FontAwesomeIcon icon={faUsers} className="inline-icon" />
                  <div className="stat-label">Number of Students</div>
                </div>
                <div className="stat-value">{studentList.length}</div>
              </div>

              <div className="stat-card">
                <div className="stat-header">
                  <FontAwesomeIcon icon={faUserCheck} className="inline-icon" />
                  <div className="stat-label">Attendance Percentage</div>
                </div>
                <div className="stat-value">{attendancePercentage}%</div>
              </div>
            </>
          )}
        </div>
      </div>

      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar
        closeOnClick
        pauseOnHover
        draggable
      />
    </>
  );
}

export default Overview;
